import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import sha1 from 'sha1'
import { decodeToken } from '../../helpers/decodeToken'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import * as loginService from '../servicios/loginService'

const Login = () => {
  const [searchParams] = useSearchParams()
  const { setLoginData, isAuthenticated } = useAuth()
  const navigate = useNavigate()

  const processLogin = async (tokenProp) => {
    try {
      // El token decodificado se envía al backend para validación — no se usa directamente
      // nosemgrep: typescript.react.security.audit.react-jwt-decoded-property.react-jwt-decoded-property
      const decoded = decodeToken(tokenProp)
      if (!decoded) return

      const { data } = await loginService.validarUsuario({
        token: decoded.token // nosemgrep: typescript.react.security.audit.react-jwt-decoded-property.react-jwt-decoded-property
      })
      const verified = data.resultado

      if (verified) {
        setLoginData(decoded) // nosemgrep: typescript.react.security.audit.react-jwt-decoded-property.react-jwt-decoded-property
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al validar el usuario.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  const processLoginDev = async () => {
    try {
      // TODO: SEGURIDAD - SHA1 es inseguro para passwords
      // El backend actualmente requiere SHA1. Se debe migrar a bcrypt/argon2
      // y mover el hashing al backend. Issue: [crear issue en GitHub]
      const { data } = await loginService.loguearUsuario({
        tipo: 'E',
        usuario: import.meta.env.VITE_USUARIO,
        empid: import.meta.env.VITE_EMPID,
        password: sha1(import.meta.env.VITE_PASS) // nosemgrep: javascript.lang.security.insecure-hash-algorithm-sha1
      })

      if (data.login) {
        setLoginData(data)
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al loguearse.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/Publicaciones')
    }
  }, [isAuthenticated, navigate])

  useEffect(() => {
    // Get token from URL parameters
    const token = searchParams.get('token')
    if (token) {
      try {
        processLogin(token)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Login failed:', error)
      }
    } else {
      processLoginDev()
    }
  }, [searchParams])

  return <></>
}

export default Login
